var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSslSecured(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 200,
    height: 71,
    viewBox: "0 0 200 71",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1165",
    "data-name": "Rectangle 1165",
    width: 91.5,
    height: 11.6,
    transform: "translate(0 0)",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_966",
    "data-name": "Group 966",
    transform: "translate(-1070 -539)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_934",
    "data-name": "Group 934",
    transform: "translate(1069.915 538.702)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_1144",
    "data-name": "Rectangle 1144",
    transform: "translate(0.085 0.298)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 200,
    height: 71,
    rx: 13,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 199,
    height: 70,
    rx: 12.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "trust_8596374",
    transform: "translate(28.78 22.193)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_926",
    "data-name": "Group 926",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2042",
    "data-name": "Path 2042",
    d: "M40.69,19.372C33.71,19.425,27.849,15,27.849,15s-5.861,4.425-12.841,4.372c0,0-.746,18.553,12.841,21.326C41.436,37.925,40.69,19.372,40.69,19.372Z",
    transform: "translate(-15 -15)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_928",
    "data-name": "Group 928",
    transform: "translate(7.704 5.012)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_927",
    "data-name": "Group 927",
    transform: "translate(3.234 8.531)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2043",
    "data-name": "Path 2043",
    d: "M220.151,270.092l1.377,1.38,2.445-2.45",
    transform: "translate(-220.151 -269.022)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_2044",
    "data-name": "Path 2044",
    d: "M167.862,215.937h-6.434a1.928,1.928,0,0,1-1.928-1.928V206.5h10.29v7.509A1.928,1.928,0,0,1,167.862,215.937Z",
    transform: "translate(-159.5 -201.302)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2045",
    "data-name": "Path 2045",
    d: "M198.726,109h0a3.226,3.226,0,0,0-3.226,3.226v1.946h6.451v-1.946A3.226,3.226,0,0,0,198.726,109Z",
    transform: "translate(-193.581 -109)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_965",
    "data-name": "Group 965",
    transform: "translate(65.085 28.298)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_964",
    "data-name": "Group 964",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2223",
    "data-name": "Path 2223",
    d: "M0,8H2.9c0,.8.4,1.4,1.7,1.4S6,9,6,8.3s-.4-.8-1.7-1c-3-.4-4-1.3-4-3.4S1.9.6,4.5.6s4,1.1,4.2,3.3H5.8A1.215,1.215,0,0,0,4.4,2.7c-.9,0-1.2.4-1.2.9s.3.9,1.7,1C7.6,4.9,9,5.6,9,7.9s-1.6,3.6-4.3,3.6S.2,10.2.1,7.9Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2224",
    "data-name": "Path 2224",
    d: "M9.6,8h2.9c0,.8.4,1.4,1.7,1.4s1.4-.4,1.4-1.1-.4-.8-1.7-1c-3-.4-4-1.3-4-3.4S11.5.6,14.1.6s4,1.1,4.2,3.3H15.4A1.215,1.215,0,0,0,14,2.7c-.9,0-1.2.4-1.2.9s.3.9,1.7,1c2.7.3,4.1,1,4.1,3.3s-1.6,3.6-4.3,3.6S9.8,10.2,9.7,7.9Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2225",
    "data-name": "Path 2225",
    d: "M20,.6h3.1V8.9h4v2.4H20Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2226",
    "data-name": "Path 2226",
    d: "M30.9,8h2.9c0,.8.4,1.4,1.7,1.4s1.4-.4,1.4-1.1-.4-.8-1.7-1c-3-.4-4-1.3-4-3.4S32.8.6,35.4.6s4,1.1,4.2,3.3H36.7a1.215,1.215,0,0,0-1.4-1.2c-.9,0-1.2.4-1.2.9s.3.9,1.7,1c2.7.3,4.1,1,4.1,3.3s-1.6,3.6-4.3,3.6S31.1,10.2,31,7.9Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2227",
    "data-name": "Path 2227",
    d: "M40.7,7.5h0a4.042,4.042,0,0,1,4.2-4.2c2.3,0,4,1.2,4,4V8H43.4A1.522,1.522,0,0,0,45,9.6c.9,0,1.3-.4,1.4-.9h2.5c-.2,1.8-1.6,2.8-4,2.8s-4.3-1.4-4.3-4Zm5.7-1A1.342,1.342,0,0,0,45,5q-1.35,0-1.5,1.5Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2228",
    "data-name": "Path 2228",
    d: "M49.7,7.5h0a3.986,3.986,0,0,1,4.2-4.2c2.3,0,3.7.8,3.8,3.2H55.2a1.164,1.164,0,0,0-1.3-1.1c-.8,0-1.5.7-1.5,2,0,1.5.5,2.2,1.5,2.2s1.3-.5,1.4-1.3h2.4c0,2-1.4,3.3-3.9,3.3s-4.1-1.4-4.1-4Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2229",
    "data-name": "Path 2229",
    d: "M58.8,8.6V3.5h2.7V8.2c0,.9.3,1.3,1.1,1.3S63.9,9,63.9,8V3.5h2.7v7.8H63.9V10.1a2.724,2.724,0,0,1-5.1-1.5",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2230",
    "data-name": "Path 2230",
    d: "M68.2,3.5h2.7V5.1a2.457,2.457,0,0,1,2.5-1.7V5.9c-1.6,0-2.5.5-2.5,1.7v3.7H68.2Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2231",
    "data-name": "Path 2231",
    d: "M74.1,7.5h0a4.042,4.042,0,0,1,4.2-4.2c2.3,0,4,1.2,4,4V8H76.8a1.522,1.522,0,0,0,1.6,1.6c.9,0,1.3-.4,1.4-.9h2.5c-.2,1.8-1.6,2.8-4,2.8S74,10.1,74,7.5Zm5.7-1A1.342,1.342,0,0,0,78.4,5q-1.35,0-1.5,1.5Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2232",
    "data-name": "Path 2232",
    d: "M83.1,7.5h0c0-2.8,1.5-4.2,3.3-4.2s2,.5,2.4,1.3V0h2.7V11.3H88.8V10a2.737,2.737,0,0,1-2.4,1.5c-1.8,0-3.3-1.3-3.3-4m5.9,0h0c0-1.4-.6-2.1-1.5-2.1s-1.5.7-1.5,2c0,1.4.6,2.1,1.5,2.1s1.6-.7,1.6-2Z",
    fill: "#fff"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSslSecured);
export default __webpack_public_path__ + "static/media/sslSecured.bdd74049a93772aeb53a5ad1bb7b0a30.svg";
export { ForwardRef as ReactComponent };